export const ENDPOINTS = {
  DRIVER_DETAILS: "/api/DriverTracker/v1.0/getDeliveryPartnerDetails",
  RESTAURANT_DETAILS: "/api/DriverTracker/v1.0/getRestaurantOrderDetails",
  ORDER_ITEMS: "/api/DriverTracker/v1.0/getDeliveryOrderItems",
  DELIVERY_INSTRUCTIONS: "/api/DriverTracker/v1.0/getDeliveryInstructions",
  CUSTOMER_INSTRUCTION: "/api/DriverTracker/v1.0/getCustomerDeliveryInstructions",
  INSERT_INSTRUCTION: "/api/DriverTracker/v1.0/insertCustomerDeliveryInstructions",
  GET_CUSTOMER_DELIVERY_INSTRUCTION:
  "/api/DriverTracker/v1.0/getCustomerDeliveryInstructions",
  SUBMIT_RATING: "/api/DriverTracker/v1.0/insertTaskDeliveryRating",
  GET_RATING: "/api/DriverTracker/v1.0/getDriverTaskRating",
  GET_DRIVER_REMAINING_TIME: "/api/DriverTracker/v1.0/getDriverRemainingTime",
};